<template>
    <div id="pages">
        <div id="container" style="width:100%;height:100vh;" />
        <div class="flexContainer r">
            <Header></Header>
            <div id="backhtml" @click="toHome">
                <i class="el-icon-arrow-left"></i>返回首页
            </div>
            <div class="right_column" style="position: absolute; top: 102px; left: 1%; width: 30%;">
                <div class="right-center">
                    <div class="right_container">
                        <div style="height: 40px"></div>
                        <div class="equipment">
                            设备编号：{{ keyword }}

                            <div class="boxRadius green" v-if="user.imeiState == 0">
                                在线
                            </div>
                            <div class="boxRadius error" v-else>
                                离线
                            </div>
                        </div>
                        <div class="user_section" style="height: 124px">

                            <img id="headimgurl" :class="showHide == 1 ? '' : 'headimgurl'" v-if="user.avatar" style="width: 100px;height: 110px;" :src="user.avatar" alt="">
                            <img id="headimgurl" :class="showHide == 1 ? '' : 'headimgurl'" v-else src="../../img/photo.png" alt="">
                            <div id="user_card">
                                <img :src="user.typeimg" alt="">
                                <span>{{ user.typeshow }}</span>
                            </div>
                            <dl>
                                <dt><img src="../../img/icon1.png" alt=""> 使用者信息</dt>
                                <dd>
                                    <span>姓      名：{{showHide == 1 ? user.name : user.names}}</span>      电话：{{showHide == 1 ? user.tel : user.tels}}
                                    <img width="18" @click="editEyeShowHide(0)" v-if="showHide == 1" src="../../img/show.png" alt="">
                                    <img width="18" @click="handClickShowHide(1)" v-else src="../../img/hide.png" alt="">
                                </dd>
                                <dd>过往病史：{{user.bs}}</dd>
                                <dd><span>紧急联系：{{showHide == 1 ? user.jj_name : user.jj_names}}</span>      电话：{{showHide == 1 ? user.jj_tel : user.jj_tels}} </dd>
                            </dl>
                        </div>
                        <div id="randtime">
                            <el-date-picker
                                v-model="startime"
                                type="date"
                                clearable
                                background="#F00"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="起始日期">
                            </el-date-picker>
                            <el-date-picker
                                style="margin-left: 36px;"
                                clearable
                                v-model="endtime"
                                type="date"
                                value-format="yyyy-MM-dd HH:mm:ss"
                                placeholder="结束日期">
                            </el-date-picker>
                            <el-button type="primary" @click="searchMap" style="margin-left: 20px; background: rgb(109, 246, 253); padding: 20px 12px; font-size: 16px; color: #0B122C;">查询</el-button>
                        </div>
                        <div class="flex_button">
                            <button class="day_btn prev_day" :class="active == 0 ? 'active' : ''" @click="handClickTime(0)">昨天</button>
                            <button class="day_btn" :class="active == 1 ? 'active' : ''" @click="handClickTime(1)">今天</button>
                            <button class="day_btn" :class="active == 2 ? 'active' : ''" @click="handClickTime(2)">7天内</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript" src="https://webapi.amap.com/maps?v=1.4.15&key=0a7464e93a3c4bc479800e388bb0bf53"></script>
<script>
import Header from '@/components/Header'
import Chartb from '@/components/Chartb'
import echarts from 'echarts';
import mapJson from '../../assets/shanxi.json';

export default {
    components: {
        Header,
        Chartb,
    },
    data () {
        return {
            showHide: 0,
            pageSize: 50,
            keyword: '',
            map: null,
            marker: null,
            lineArr: [],
            active: '-1',
            startime: '',
            maxnum: 0,
            endtime: '',
            mapList: [],
            user: {
                avatar: '',
                imei: '--',
                name: '--',
                tel: '--',
                bs: '--',
                jj_name: '--',
                jj_tel: '--',
                title: '--',
                address: '-------',
                type: '',
                imeiState: ''
            },
            refreshData: null
        }
    },
    mounted() {
        var _this = this
        _this.clickTimes()
        this.$nextTick(() => {
            _this.getMap();
            _this.getUserShow();
            setTimeout(()=>{
                _this.initMap()
            },1000)
        });
        _this.keyword = this.$route.query.keyword
    },
    beforeDestroy() {
        this.map && this.map.destroy();
    },
    methods: {
        clickTimes(){
            this.timer = setInterval(() => {
                this.getUserShow();
            }, 30000)
        },
        getUserShow(){
            var that = this
            that.axios.get(this.$url.baseUrl+'index/usershow?value='+that.keyword, {
                    headers: {
                        'Content-Type':'application/x-www-form-urlencoded',
                    }
                })
                .then(function (res) {
                    // console.log(res.data.data,"数据")
                    that.showHide = parseInt(res.data.data.showhide)
                    if(res.data.code == 1){
                        that.user = res.data.data
                    }
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        handClickShowHide(i){
            var that = this
            if(i == 1){
                this.$prompt('请输入密码', '提示', {
                    inputType: 'password',
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(({ value }) => {
                    if(value == 'sxjxrhhhxt'){
                        that.editEyeShowHide(i);

                    }else{
                        this.$alert('<p>密码有误，请重新输入</p>', {
                            dangerouslyUseHTMLString: true
                        });
                    }
                }).catch(() => {
                    this.$alert('<p>取消输入</p>', {
                        dangerouslyUseHTMLString: true
                    });
                });
                return false
            }
        },
        editEyeShowHide(i){
            var that = this
            console.log(i)
            that.showHide = parseInt(i)
            // console.log(that.showHide,"显示隐藏状态")

            that.axios.get(that.$url.baseUrl+'index/saveconfig?value='+i, {

                })
                .then(function (res) {
                    that.getUserShow();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        // handClickShowHide(i){
        //     var that = this
        //     that.axios.get(that.$url.baseUrl+'index/saveconfig?value='+i, {
        //
        //         })
        //         .then(function (res) {
        //             that.getUserShow();
        //         })
        //         .catch(function (error) {
        //             console.log(error);
        //         });
        // },
        handClickTime (i) {
            this.active = i
            this.startime = ''
            this.endtime = ''
            this.getMap();
        },
        searchMap(){
            if(!this.startime){
                this.$message.error('请选择开始时间')
                return false
            }
            if(!this.endtime){
                this.$message.error('请选择结束时间')
                return false
            }
            this.active = '-1'
            this.pageSize = 100
            this.getMap();
        },
        getMap(){
            var that = this
            that.axios.post(this.$url.baseUrl+'index/getMap', {
                    params: {
                        deviceid: that.keyword,
                        startime: that.startime,
                        endtime: that.endtime,
                        status: that.active,
                        pageSize: this.pageSize,
                    }
                })
                .then(function (res) {

                    that.lineArr = res.data.map_list

                    that.maxnum = res.data.maxnum

                    that.initMap();
                })
                .catch(function (error) {
                    console.log(error);
                });
        },
        initMap() {
            var that = this
            console.log(that.lineArr[0],"数据1AA");
            var map = new AMap.Map("container", {
                resizeEnable: true,
                center: that.lineArr[0],
                zoom: 12,
                viewMode: "3D", //使用3D视图
                mapStyle: "amap://styles/darkblue",//样式
            });

            that.marker = new AMap.Marker({
                map: map,
                position: that.lineArr[that.maxnum],
                icon: "https://ybscfx4.shop.baidusx.com/h5/map.png",
                offset: new AMap.Pixel(-26, -15),
                autoRotation: true,
                angle: -90
            });
            // 绘制轨迹
            let polyline = new AMap.Polyline({
                map: map,
                path: that.lineArr,
                showDir: true,
                strokeColor: "#7afdfd", //线颜色
                // strokeOpacity: 1,     //线透明度
                strokeWeight: 3, //线宽
                strokeStyle: "dashed"  //线样式
            });

            let passedPolyline = new AMap.Polyline({
                map: map,
                strokeColor: "#AF5", //线颜色
                // strokeOpacity: 1,     //线透明度
                strokeWeight: 3, //线宽
                strokeStyle: "dashed"  //线样式
            });
            that.marker.on("moving", function (e) {
                passedPolyline.setPath(e.passedPath);
            });

            that.map.setFitView();

        },
        toHome(){
            this.$router.go(-1);
        }
    }
};
</script>

<style scoped>

input:focus{
    border: 1px solid #DCDFE6;
}
.r .right_column{
    width: 450px;
    height: 48%;
    float: left;
    display: inline-block;
    margin-left: 1%;
    background: url(../../img/bg1.png) no-repeat;
    background-size: 100% 100%;
    background-color: rgba(0,0,0,.8);
}
.flexContainer #header{
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    z-index: 3;
}
#cdc-track{
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    width: 100%;
    height: 100%;
}
.day_btn{
    flex: 1;
    height: 50px;
    color: #6DF6FD;
    font-size: 16px;
    cursor: pointer;
    column-gap: 20px;
    background: none;
    line-height: 50px;
    margin-left: 25px;
    border-radius: 3px;
    grid-column-gap: 20px;
    border: 1px solid #6DF6FD;
}
.flex_button .active{
    color: #0b122c;
    background: #6DF6FD;
}
.flex_button .prev_day{
    margin-left: 0;
}
.flex_button{
    display: flex;
    margin-top: 28px;
}
#randtime::after{
    content: '';
    display: block;
    clear: both;
    width: 16px;
    height: 2px;
    background: #6D7181;
    position: absolute;
    top: 26px;
    left: 182px;
}
#randtime{
    position: relative;
    margin-top: 25px;
}
.right-center .el-input__inner{
    background: #1E2E42 !important;
}
#randtime .el-date-editor.el-input{
    width: 170px;
    height: 58px;

}
#user_card span{
    position: absolute;
    display: inline-block;
    top: 3px;
    left: 28px;
    color: #07184a;
    font-size: 10px;
}
#user_card{
    display: inline-block;
    position: absolute;
    right: 0;
    bottom: 0;
}
.right_column{
}
.user_section{
    position: relative;
}
#headimgurl{
    position: absolute;
    right: 0;
    top: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/history.vue